import { render } from "./TagSummary.vue?vue&type=template&id=f4e5d58c"
import script from "./TagSummary.vue?vue&type=script&lang=js"
export * from "./TagSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__